import React, { useContext, Fragment, useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";
import Icon from "@mdi/react";
import { mdiPlay } from "@mdi/js";

import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import ListIcon from "@mui/icons-material/List";
import ArticleIcon from "@mui/icons-material/Article";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Button from "@mui/material/Button";
import { ListGroup, ListGroupItem } from "react-bootstrap";
import { getCourses } from "ServerAPI/serverAPI";
import { useCookies } from "react-cookie";
import CodeIcon from "@mui/icons-material/Code";
import DoneIcon from "@mui/icons-material/Done";
import AudiotrackIcon from "@mui/icons-material/Audiotrack";
import ImageIcon from "@mui/icons-material/Image";

const Sidebar = ({
  accordionItems,
  getActiveContent,
  activeContent,
  isSubmittingQuiz,
  setCompletedSection,
  isCourseCompleted,
  isQuizInProgress,
}) => {
  const [type, setType] = useState("");
  const { courseId } = useParams();
  const [selectedSubitem, setSelectedSubitem] = useState(null);
  const [openAccordion, setOpenAccordion] = useState(null);
  const location = useLocation();
  const [cookies] = useCookies();
  const [activeSection, setActiveSection] = useState(null);

  useEffect(() => {
    if (isSubmittingQuiz) return;

    const urlParts = location.pathname.split("/");
    const contentIdFromUrl = urlParts[urlParts.length - 1];
    setSelectedSubitem(contentIdFromUrl);
    const findSelectedSubitem = accordionItems
      .flatMap((item) => item.courseContent)
      .find((subitem) => subitem.contentId === contentIdFromUrl);

    if (findSelectedSubitem) {
      setType(findSelectedSubitem.contentType);
      getActiveContent(findSelectedSubitem);

      const parentAccordion = accordionItems.find((item) =>
        item.courseContent.some(
          (subitem) => subitem.contentId === contentIdFromUrl
        )
      );
      setOpenAccordion(parentAccordion.sectionId);
    }
  }, [location.pathname, accordionItems, getActiveContent, isSubmittingQuiz]);

  const handleSubitemClick = (subitem) => {
    setType(subitem.contentType);
    getActiveContent(subitem);
    setSelectedSubitem(subitem.contentId);

    const parentAccordion = accordionItems.find((item) =>
      item.courseContent.some(
        (subitem) => subitem.contentId === subitem.contentId
      )
    );
    setOpenAccordion(parentAccordion.sectionId);
  };

  return (
    <>
      {accordionItems?.length > 0 &&
        accordionItems.map((item, index) => {
          if (item?.courseContent?.length !== 0) {
            return (
              <Accordion

                key={item.sectionId}
                className="bg-white mt-0 p-0 border-0"
                expanded={openAccordion === item.sectionId}
                onChange={
                  isQuizInProgress
                    ? undefined // By setting to undefined, the component acts as 'uncontrolled' or disabled.
                    : () =>
                      setOpenAccordion(
                        openAccordion === item.sectionId ? null : item.sectionId
                      )
                }
              >
                <AccordionSummary
                  expandIcon={
                    <ExpandMoreIcon className="bg-white text-dark dark:bg-dark-800 dark:text-white" />
                  }
                  className="bg-white text-dark dark:bg-dark-800 dark:text-white"
                >
                  <div>
                    <span>Section {index + 1}:</span>
                    <span className="mx-1">{item.sectionTitle}</span>
                  </div>
                </AccordionSummary>
                <AccordionDetails className="my-0 p-0">
                  <ListGroup as="ul" className="my-0 p-0">
                    {item.courseContent
                      .sort((a, b) => a.contentNumber - b.contentNumber)
                      .map((subitem) => {
                        return (
                          <Link
                            to={`/view-course/${courseId}/${item.sectionId}/${subitem.contentId}`}
                            onClick={() => {
                              if (isQuizInProgress) {
                                e.preventDefault();
                                e.stopPropagation(); // Stop event from bubbling up
                                return;
                              }
                              setActiveSection(index);
                              handleSubitemClick(subitem);
                            }}
                            className={`d-flex justify-content-between align-items-center text-inherit text-decoration-none  px-4 py-3 m-0`}
                            key={subitem.contentId}
                            style={{
                              background: selectedSubitem === subitem.contentId ? "#DEE7F8" : "",
                              pointerEvents: isQuizInProgress ? "none" : "auto", // FREEZE NAVIGATION
                              color: isQuizInProgress ? "gray" : "inherit", // VISUAL FEEDBACK
                            }}
                          // style={{
                          //   background:
                          //     selectedSubitem === subitem.contentId
                          //       ? "#DEE7F8"
                          //       : "",
                          //   pointerEvents:
                          //     cookies.roleId === "courseParticipant" &&
                          //     subitem?.finalAssessment &&
                          //     !isCourseCompleted
                          //       ? "none"
                          //       : "auto",
                          //   color:
                          //     cookies.roleId === "courseParticipant" &&
                          //     subitem?.finalAssessment &&
                          //     !isCourseCompleted
                          //       ? "gray"
                          //       : "",
                          // }}
                          //                             style={{
                          //   background: selectedSubitem === subitem.contentId ? "#DEE7F8" : "",
                          //   pointerEvents: "auto",
                          //   color: "inherit",  
                          // }}
                          >
                            <div className="text-truncate d-flex align-items-center">
                              <div
                                style={{
                                  width: "20px",
                                  height: "20px",
                                  border: subitem?.completed
                                    ? "1px solid green"
                                    : "1px solid black",
                                  borderRadius: "50%",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  padding: ".7rem",
                                }}
                              >
                                {subitem?.completed ? (
                                  <DoneIcon sx={{ color: "green" }} />
                                ) : (
                                  ""
                                )}
                              </div>
                              <span
                                className={`icon-shape icon-sm rounded-circle me-3 mx-3 ${selectedSubitem === subitem.contentId
                                  ? "bg-light-green text-light-green"
                                  : "bg-light"
                                  }`}
                              >
                                {subitem.contentType ===
                                  "supplementaryMaterial" ? (
                                  <ArticleIcon
                                    size={1.5}
                                    style={{
                                      color:
                                        selectedSubitem === subitem.contentId
                                          ? "#23509E"
                                          : "inherit",
                                    }}
                                  />
                                ) : null}
                                {subitem.contentType === "video" ? (
                                  <PlayCircleIcon
                                    style={{
                                      color:
                                        selectedSubitem === subitem.contentId
                                          ? "#23509E"
                                          : "inherit",
                                      fontSize: "2rem",
                                    }}
                                  />
                                ) : null}
                                {subitem.contentType === "quiz" || subitem.contentType === "quizSubjective" ? (
                                  <HelpOutlineIcon
                                    style={{
                                      color:
                                        selectedSubitem === subitem.contentId
                                          ? "#23509E"
                                          : "inherit",
                                      fontSize: "2rem",
                                    }}
                                  />
                                ) : null}
                                {subitem.contentType === "codeSandbox" ? (
                                  <CodeIcon
                                    style={{
                                      color:
                                        selectedSubitem === subitem.contentId
                                          ? "#23509E"
                                          : "inherit",
                                      fontSize: "2rem",
                                    }}
                                  />
                                ) : null}

                                {subitem.contentType === "image" ? (
                                  <ImageIcon
                                    style={{
                                      color:
                                        selectedSubitem === subitem.contentId
                                          ? "#23509E"
                                          : "inherit",
                                      fontSize: "2rem",
                                    }}
                                  />
                                ) : null}

                                {subitem.contentType === "audio" ? (
                                  <AudiotrackIcon
                                    style={{
                                      color:
                                        selectedSubitem === subitem.contentId
                                          ? "#23509E"
                                          : "inherit",
                                      fontSize: "2rem",
                                    }}
                                  />
                                ) : null}
                              </span>

                              <span
                                className={`fs-5 ${selectedSubitem === subitem.contentId
                                  ? "text-primary"
                                  : ""
                                  }`}
                              >
                                {subitem.contentTitle}
                              </span>
                            </div>
                            <div className="text-truncate d-flex align-items-center">
                              <span>{subitem.duration}</span>
                            </div>
                          </Link>
                        );
                      })}
                  </ListGroup>
                </AccordionDetails>
              </Accordion>
            );
          }
          return null;
        })}
    </>
  );
};

export default Sidebar;
